import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';
import Link from '@/components/Link';
import CarSelectionHelperDie from '@/components/CarSelectionHelperDie';

import { StockTabsPanelProps } from './types';

function StockTabsPanel({
  tabs,
  activeTab,
  die,
  children,
}: StockTabsPanelProps) {
  return (
    <Component>
      <Tabs>
        <Left>
          {tabs.map((tab, index) => (
            <Tab key={index} to={tab.link} isActive={activeTab === tab.label}>
              {tab.label}
              {tab.badge && <Badge>{tab.badge}</Badge>}
            </Tab>
          ))}
        </Left>

        {die && die.text && (
          <Right>
            <CarSelectionHelperDie
              text={die.text}
              imageOn={die.imageOn}
              imageOff={die.imageOff}
              onClick={die?.onClick}
            />
          </Right>
        )}
      </Tabs>

      {children && <Content>{children}</Content>}
    </Component>
  );
}

export default StockTabsPanel;

const Component = styled.div`
  width: 100%;
`;

const Tabs = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Left = styled.div`
  display: flex;
  margin-right: 20px;
`;

const Right = styled.div`
  width: 100%;
  max-width: 335px;
`;

const Tab = styled(Link)<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  text-align: center;
  height: 60px;
  padding: 20px 30px;
  font-size: 16px;
  line-height: 19px;
  background: ${(props) => props.theme.gray_1};
  color: ${(props) => props.theme.blue100};
  border-bottom: 1px solid ${(props) => props.theme.gray};

  &:not(:first-child) {
    margin-left: 5px;
  }

  &:first-child {
    border-top-left-radius: 15px;
  }

  &:last-child {
    border-top-right-radius: 15px;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      pointer-events: none;
      font-weight: 700;
      background: ${colors.main};
      color: ${colors.white};
      border-bottom: none;
    `}
`;

const Badge = styled.div`
  padding: 1px 7px;
  font-size: 10px;
  line-height: 12px;
  margin-left: 5px;
  background: #eb3724;
  border-radius: 25px;
  color: ${colors.white};
`;

const Content = styled.div`
  width: 100%;
  padding: 40px 25px 30px;
  border-radius: 0 0 15px 15px;
  background: ${(props) => props.theme.white_1};
  box-shadow: 0 0 20px rgba(23, 43, 77, 0.1);
`;
